import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBell2Snooze: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBell2Snooze"><Path fillRule="evenodd" clipRule="evenodd" d="M4.75447 8.87114C4.94782 5.0198 8.13655 2 12 2C15.8634 2 19.0522 5.02005 19.2455 8.87139L19.444 12.8003L21 15.818V18H16.6911C16.3315 20.267 14.3682 22 12 22C9.63185 22 7.66846 20.267 7.30888 18H3V15.818L4.556 12.8003L4.75447 8.87114ZM8.83697 18C9.17555 19.4333 10.4632 20.5 12 20.5C13.5368 20.5 14.8245 19.4333 15.163 18H8.83697ZM9.5 7.5V9H12.4751L9.5 11.8688V13.5H14.5V12H11.5249L14.5 9.13118V7.5H9.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBell2Snooze;
